import React from 'react';

import Toast from 'honeydew/Toast';
import useGlobalStore from 'hooks/useGlobalStore';

function RecurringToast() {
    const { recurringToast, setRecurringToast } = useGlobalStore();

    const handleCloseRecurringToast = (_, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setRecurringToast({ open: false, itemName: '', action: '', timestamp: null });
    };

    return (
        <Toast
            key={recurringToast.timestamp}
            open={recurringToast.open}
            handleClose={handleCloseRecurringToast}
            autoHideDuration={3000}
            extendedStyles={{ marginBottom: 'font-grotesk z-[4000]' }}
            copy={
                recurringToast.action === 'added' ? (
                    <>
                        Added <span className="font-grotesk-bold">{recurringToast.itemName}</span> to your recurring
                        list
                    </>
                ) : (
                    <>
                        Removed <span className="font-grotesk-bold">{recurringToast.itemName}</span> from your recurring
                        list
                    </>
                )
            }
        />
    );
}

export default RecurringToast;
